import { createAction } from '../../utils/redux/createAction';

const actionScope = 'device-permission';

export const DEVICE_PERMISSION_ACTION_TYPES = {
  OPEN: `${actionScope}/open`,
  CLOSE: `${actionScope}/close`,
  RETRY: `${actionScope}/retry`,
  GRAND_PERMISSION: `${actionScope}/grand-permission`,
};

export const devicePermissionActions = {
  open: createAction(DEVICE_PERMISSION_ACTION_TYPES.OPEN),
  close: createAction(DEVICE_PERMISSION_ACTION_TYPES.CLOSE),
  retry: createAction(DEVICE_PERMISSION_ACTION_TYPES.RETRY),
  mediaPermissionsGranted: createAction(
    DEVICE_PERMISSION_ACTION_TYPES.GRAND_PERMISSION,
  ),
};

const initialState = {
  opened: false,
  props: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DEVICE_PERMISSION_ACTION_TYPES.OPEN: {
      return { ...state, opened: true, props: payload };
    }
    case DEVICE_PERMISSION_ACTION_TYPES.CLOSE: {
      return { ...state, opened: false, props: {} };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/devicePermissions.js